// [hiperautomacao] The instance database refuses invalid CRM writes with a
// message that starts with "CRM: " and is already written for the seller.
// This turns any error into that message, without the prefix.
export const crmErrorMessage = (error: unknown): string => {
  const raw =
    error instanceof Error
      ? error.message
      : typeof error === "object" && error !== null && "message" in error
        ? String((error as { message: unknown }).message)
        : String(error);
  const match = raw.match(/CRM:\s*(.*)$/s);
  return match ? match[1].trim() : raw;
};
